import React from "react";
import { useLocation } from "react-router-dom";
import MedicationHistoryIP from "./MedicationsIp/MedicationHistoryIP";
import ClinicalPractitionerIA from "./ClinicalPractitioner/ClinicalPractitionerIA";
import ClinicalPractitionerReview from "./ClinicalPractitioner/ClinicalPractitionerReview";
import ClinicalPractitionerFormById from "./ClinicalPractitioner/ClinicalPractitionerFormById";
import { detectAdmissionType } from "./ClinicalPractitioner/admissionContext";

const CLINICAL_FORM_PREFIX = "clinical-form-";

const ClinicalPractitionerIP = ({ patientData, params }) => {
  const { pathname, search } = useLocation();
  const admissionType = detectAdmissionType(pathname, search);
  const admissionId = params?.patient;
  const type = params?.type;

  if (type === "medicine") {
    return <MedicationHistoryIP patientData={patientData} />;
  }
  if (type === "ia") {
    return (
      <ClinicalPractitionerIA
        admissionId={admissionId}
        admissionType={admissionType}
      />
    );
  }
  if (type === "review") {
    return (
      <ClinicalPractitionerReview
        admissionId={admissionId}
        admissionType={admissionType}
      />
    );
  }
  if (typeof type === "string" && type.startsWith(CLINICAL_FORM_PREFIX)) {
    const formId = type.slice(CLINICAL_FORM_PREFIX.length);
    return (
      <ClinicalPractitionerFormById
        formId={formId}
        admissionId={admissionId}
        admissionType={admissionType}
      />
    );
  }
  return null;
};

export default ClinicalPractitionerIP;
